import React from 'react';
import { Comment01Icon } from 'hugeicons-react';
import { stripMessageContent } from '../../helpers/chatHelper';
import { SearchResult } from '../../types/search';
import { formatRelativeTime, highlightMatch } from './utils';

interface SearchResultsProps {
  results: SearchResult[];
  searchQuery: string;
  isLoadingMore: boolean;
  hasMoreResults: boolean;
  onResultClick: (result: SearchResult) => void;
  loadingRef: React.RefObject<HTMLDivElement | null>;
  selectedIndex?: number;
}

export const SearchResults: React.FC<SearchResultsProps> = ({
  results,
  searchQuery,
  isLoadingMore,
  hasMoreResults,
  onResultClick,
  loadingRef,
  selectedIndex = -1
}) => {
  return (
    <>
      {results.map((result, index) => (
        <SearchResultItem 
          key={`${result.id}_${result.chatId}`}
          result={result}
          searchQuery={searchQuery}
          onClick={() => onResultClick(result)}
          isSelected={index === selectedIndex}
          id={`search-result-${index}`}
        />
      ))}
      <div ref={loadingRef} className="loading-indicator">
        {isLoadingMore && hasMoreResults && (
          <div className="loading-spinner"></div>
        )}
      </div>
    </>
  );
};

interface SearchResultItemProps {
  result: SearchResult;
  searchQuery: string;
  onClick: () => void;
  isSelected?: boolean;
  id?: string;
}

export const SearchResultItem: React.FC<SearchResultItemProps> = ({ 
  result, 
  searchQuery, 
  onClick,
  isSelected = false,
  id
}) => {
  return (
    <div 
      className={`search-result-item ${isSelected ? 'keyboard-selected' : ''}`}
      onClick={onClick}
      role="option"
      aria-selected={isSelected}
      id={id}
      tabIndex={isSelected ? 0 : -1}
    >
      <div className='search-result-item-left'>
        <Comment01Icon size={20}/>
      </div>
      <div className='search-result-item-right'>
        <div className='search-result-item-preview'>
          <div className="search-result-item-header">
            <h4>{result.chatTitle}</h4>
          </div>
          <p className="search-result-item-content">
            {highlightMatch(stripMessageContent(result.preview), searchQuery)}
          </p>
        </div>
        <div className='search-result-item-time'>
          <span className="time-text">{formatRelativeTime(result.timestamp)}</span>
        </div>
      </div>
    </div>
  );
};